import { Component, OnInit } from '@angular/core';
import { RawMaterialModel } from '../../../../shared/entities/raw-material.model';
import { SttTableComponent } from '../../../../shared/components/stt-table/stt-table.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { ValidationMessageService } from '../../../../shared/services/base/validation-message-handle';
import {
    RawMaterialsAddEditComponent
} from '../../raw-materials/raw-materials-add-edit/raw-materials-add-edit.component';
import { finalize } from 'rxjs/operators';
import { RawMaterialGroupService } from '../../../../shared/services/app/raw-material-group.service';
import { RawMaterialGroupModel } from '../../../../shared/entities/raw-material-group.model';
import { RawMaterialGroupAddEditComponent } from '../raw-material-group-add-edit/raw-material-group-add-edit.component';

@Component({
  selector: 'app-raw-material-group-action-table',
  templateUrl: './raw-material-group-action-table.component.html',
  styleUrls: ['./raw-material-group-action-table.component.scss']
})
export class RawMaterialGroupActionTableComponent implements OnInit {

    public data: RawMaterialGroupModel;
    public table: SttTableComponent;
    public ref: DynamicDialogRef;
    public loading = true;

    constructor(
        public dialogService: DialogService,
        public confirmationService: ConfirmationService,
        public primengConfig: PrimeNGConfig,
        public itemService: RawMaterialGroupService,
        public messageService: MessageService,
        private validationMessageService: ValidationMessageService,
    ) {

    }

    ngOnInit(): void {
    }

    setParams(entity: RawMaterialGroupModel): void {
        this.data = entity;
    }

    setTableReference(table: SttTableComponent): void {
        this.table = table;
    }


    showDialog() {
        this.ref = this.dialogService.open(RawMaterialGroupAddEditComponent, {
            header: 'Modificare Materie Prima',
            width: '30%',
            contentStyle: { 'max-height': '70vh' },
            baseZIndex: 10000,
            closeOnEscape: false,
            data: this.data,
        });

        this.ref.onClose.subscribe((raw_material_group: RawMaterialGroupModel) => {
            if (raw_material_group) {
                this.table.refresh();
            }
        });
    }


    confirm() {
        this.confirmationService.confirm({
            header: 'Confirmare stergere Grup Materie prima',
            message: 'Sunteti sigur ca doriti sa stergeti acest Grup de Materie prima?',
            key: 'deleteRawMaterialGroup',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Da',
            rejectLabel: 'Nu',
            acceptButtonStyleClass: 'p-button-md p-button-success',
            rejectButtonStyleClass: 'p-button-md p-button-danger',
            accept: () => {
                this.deleteItem(this.data.uid);
            },
            reject: () => {
                this.confirmationService.close();
                this.table.refresh();
            }
        });
    }

    deleteItem(uid: string){
        this.itemService.delete(uid)
            .pipe(finalize(() => {this.loading = false;this.table.refresh();}))
            .subscribe((response: any) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Grupul de materie prima a fost sters cu success!'
                });
            });
    }
}
